export const flicketLogo = "/static/flicket.png";

export const DOT_SEPARATOR = "•";
